export const color_strong_cyan = "hsl(172, 67%, 45%)";

// Neutral

export const color_very_dark_cyan = "hsl(183, 100%, 15%)";
export const color_dark_grayish_cyan = "hsl(186, 14%, 43%)";
export const color_grayish_cyan = "hsl(184, 14%, 56%)";
export const color_light_grayish_cyan = " hsl(185, 41%, 84%)";
export const color_very_light_grayish_cyan = "hsl(189, 41%, 97%)";
export const color_white = "hsl(0, 0%, 100%)";

export const form_field_fontsize = "2.4rem";
